const getOrderLinePlaceOfService = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine) {
      return indexOrderLine['Place of SRV'] || indexOrderLine.placeOfSRV;
    }
    return null;
  }
  return orderLine
    ? orderLine.map(item => item['Place of SRV'] || item.placeOfSRV).join(', ')
    : null;
};

export default getOrderLinePlaceOfService;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLinePlaceOfService.js